import React from 'react'

const MenuIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.993045 4.03969C0.393536 4.18255 0.075757 4.58445 0.0103319 5.28143C-0.0537581 5.97841 0.182574 6.53385 0.656572 6.79689L0.927619 6.94643H23.0921L23.311 6.82893C23.5848 6.6834 23.8331 6.403 23.9266 6.13596C24.02 5.87293 24.02 5.08248 23.9266 4.81945C23.8064 4.5131 23.5751 4.26329 23.279 4.1198L23.0387 4.00898L12.1167 4.00097C5.82783 3.99562 1.10921 4.01298 0.993045 4.03969ZM0.856853 10.5996C0.276038 10.7998 0.0196783 11.2271 0.0196783 11.9935C0.0196783 12.5543 0.133171 12.8761 0.42024 13.1351C0.839496 13.5143 -0.00302039 13.4889 12.0098 13.4889C24.0227 13.4889 23.1802 13.5143 23.5994 13.1351C23.8865 12.8761 24 12.5543 24 11.9935C24 11.4327 23.8865 11.1109 23.5994 10.8519C23.1802 10.4727 24.0267 10.4981 11.9871 10.4994C1.60457 10.5021 1.12924 10.5061 0.856853 10.5996ZM0.977022 17.0633C0.304077 17.2262 -0.0684455 17.8604 0.011667 18.7109C0.0677457 19.3158 0.357486 19.7391 0.830149 19.906C1.13591 20.0141 22.8851 20.0128 23.1922 19.9046C23.5113 19.7768 23.767 19.5283 23.9039 19.213C24.02 18.9099 24.0334 18.1555 23.9266 17.8511C23.8331 17.584 23.5848 17.3036 23.311 17.1581L23.0921 17.0406L12.1167 17.0326C6.08018 17.0272 1.06782 17.0419 0.977022 17.0633Z"
        clipRule="evenodd"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default MenuIcon
